import React, { useEffect } from 'react'
import {
  makeStyles,
  createStyles,
  Box,
  IconButton,
  Typography,
  Chip,
  useMediaQuery,
  useTheme,
  Divider,
} from '@material-ui/core'
import { useHistory, Link } from 'react-router-dom'
// import { ReactComponent as CloseIcon } from 'src/mobile/assets/icons/close.svg'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { MOBILE_HEADER_HEIGHT } from 'src/mobile/utils/constant'
import useUserSession from 'src/hooks/useUserSession'
import useRedirectAfterLogin from 'src/hooks/useRedirectAfterLogin'
// import { useLastLocation } from 'react-router-last-location'
import { useTranslation } from 'react-i18next'
import { useImageTranslation } from 'src/hooks'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1, 2.5),
      background: '#fff',
    },
    closeWrapper: {
      height: theme.spacing(MOBILE_HEADER_HEIGHT),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      marginLeft: theme.spacing(-0.5),
      padding: theme.spacing(0, 2.5),
    },
    logoBox: {},
    logo: {
      display: 'block',
      width: theme.spacing(12),
    },
    title: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: 26,
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
        textAlign: 'center',
      },
    },
    closeBtn: {},
    closeIcon: {
      width: theme.spacing(3.5),
      height: theme.spacing(3.5),
      '& path': {
        stroke: theme.palette.primary.main,
      },
    },
    chipBox: {
      borderRadius: 20,
      position: 'absolute',
      top: theme.spacing(2.5),
      borderColor: theme.palette.primary.light,
    },
    IconButton: {
      position: 'absolute',
      marginTop: 40,
      border: '1px solid #D1D5DB',
      borderRadius: 100,
      padding: 6,
      [theme.breakpoints.down('xs')]: {
        marginTop: 0,
        border: 0,
        borderRadius: 0,
        padding: 0,
      },
    },
  }),
)

const AuthHeader = ({ children, title, goStepOne, step, showLogo, hideLogo, source }) => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const { authenticated } = useUserSession()
  const redirectAfterLogin = useRedirectAfterLogin()
  // const lastLocation = useLastLocation()
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()
  const currentPath = history.location.pathname
  useEffect(() => {
    if (authenticated) redirectAfterLogin({ redirectUrl: `/${i18n.language}` })
  }, [])

  // const handleClose = () => (lastLocation ? history.goBack() : history.push('/'))

  return (
    <>
      {/* <AppBar elevation={0} position="sticky" className={classes.closeWrapper}>
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </AppBar> */}
      {hideLogo && (
        <Box my={2} mx={2} className={classes.logoBox}>
          <img className={classes.logo} src={tImage('logo', 'png')} />
        </Box>
      )}

      <Box className={classes.root} mt={2}>
        {step === 2 ? (
          <Box>
            {source !== 'order' && (
              <Box height={isMobile ? 'auto' : 64}>
                <IconButton size="small" className={classes.IconButton} onClick={goStepOne}>
                  <ArrowBackIcon />
                </IconButton>
              </Box>
            )}
            {!isMobile && source !== 'order' ? (
              <Box mt={3} fontSize={26} fontWeight={600}>
                {currentPath === `/${i18n.language}/signup` ? '' : t('common.set_new_pwd')}
              </Box>
            ) : (
              ''
            )}
          </Box>
        ) : (
          !showLogo &&
          isMobile &&
          source !== 'order' && (
            <Link
              to={
                currentPath === `/${i18n.language}/signup`
                  ? `/${i18n.language}/signin`
                  : `/${i18n.language}/signup`
              }
            >
              <Chip
                label={
                  currentPath === `/${i18n.language}/signup` ? t('common.sign_in') : t('common.register')
                }
                variant="outlined"
                className={classes.chipBox}
              />
            </Link>
          )
        )}

        {title &&
          source !== 'order' &&
          (showLogo && step === 1 ? (
            ''
          ) : (
            <Box mt={isMobile ? 0 : 5}>
              <Typography className={classes.title} color="primary">
                {title}
              </Typography>
            </Box>
          ))}

        {children}
      </Box>
      {isMobile && step === 2 && (
        <Box mt={1}>
          <Divider />
        </Box>
      )}
    </>
  )
}

export default AuthHeader
